// The `has-hover` package, which is a dependency of `plotly.js`, is attempting to access the global object.
// Typically occurs when code written for a Node.js environment is executed in a browser environment.
// Node.js uses global as its global object, while browsers use window. So we need to set the global object to window.
(window as any).global = window;
